import * as React from "react"


export const FooterBottomLink = (
  props: {
    href:string,
    title:string,
    className?:string
    onClick?:() => void
  }
) => (
  <a
      href={props.href}
      className={`subfooter__link`}
      onClick={(e) => {
        if(props.onClick) {
          e.preventDefault();
          props.onClick();
        }
      }}
    >
      {props.title}
  </a>
);
